import React from 'react'
import Guidelines from './Guidelines'
import QuestionsCollapse from '../QuestionsCollapse'

const GuidelinesSection = ({ question }) => {
    return question.children ? (
        <QuestionsCollapse question={question} ContentComponent={Guidelines} />
    ) : (
        <Guidelines question={question} />
    )
}

export default GuidelinesSection
